<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto" >
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <div>Disputas</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="toggleFilters">
            <v-icon>filter_list</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    
    <!-- Filtros -->
    <v-expand-transition>
      <div v-show="showFilters">
        <filters />
      </div>
    </v-expand-transition>
    
    <v-layout v-resize="onResize" column style="padding-top:56px">
    <v-data-table flat
      :headers="headers"
      :items="resources"
      class="elevation-2"
      :loading="isLoading"
      :hide-headers="isMobile" :class="{mobile: isMobile}"
      click:row
    >
      <template slot="items" slot-scope="props">
        <tr v-if="!isMobile">
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ $n((props.item.amount), 'currency') }}</td>
                  <td class="text-xs-left">{{ props.item.payment_id }}</td>
                  <td class="text-xs-left">{{ props.item.reason }}</td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.date) }}</td>
                  <td class="text-xs-left">
                    <v-btn class="ma-2" color="indigo" dark @click="sendForm(props.item.id)">Enviar
                      <v-icon dark>attach_file</v-icon>
                    </v-btn>
                  </td>
                </tr>
                <tr v-else>
                  <td>
                    <ul class="flex-content">
                      <li class="flex-item" data-label="ID">{{ props.item.id }}</li>
                      <li class="flex-item" data-label="Valor">{{  $n((props.item.amount), 'currency') }}</li>
                      <li class="flex-item" data-label="Pagamento">{{ props.item.payment_id }}</li>
                      <li class="flex-item" data-label="Bandeira">{{ props.item.reason }}</li>
                      <li class="flex-item" data-label="Data">{{ setDateFormat(props.item.date) }}</li>
                      <li class="flex-item" data-label="Enviar Recibo">
                        <v-btn class="ma-2" color="indigo" dark @click="sendForm(props.item.id)">Enviar
                          <v-icon dark>attach_file</v-icon>
                        </v-btn>
                      </li>
                    </ul>
                  </td>
                  </tr>
      </template>
    </v-data-table>
    <modal />
  </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/services/event-bus';

export default {
  /* eslint-disable */
  name: 'Main',
  props: ['row'],
  created() {
    this.$store.dispatch('chargebacks/loadList');
  },
  computed: {
    ...mapGetters({
      resources: 'chargebacks/getList',
      isLoading: 'chargebacks/load',
      dialog: 'chargebacks/dialog',
      showFilters: 'chargebacks/showFilters'
    }),
    pages() {
      return 0;
    },
  },
  components: {
    Modal: () => import('./Modal.vue'),
    Filters: () => import('./Filters.vue'),
  },
  methods: {
    ...mapActions({
      showFiltersAction: 'chargebacks/showFilters'
    }),
    
    toggleFilters() {
      this.showFiltersAction(!this.showFilters);
    },
    
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    setDateFormat(date) {
      if (date === null) {
        return '';
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    },
    sendForm(id) {
      if (this.dialog == false) {
        this.$store.commit('chargebacks/DIALOG', true);
        this.$store.commit('chargebacks/ID', id);
      } else {
        this.$store.commit('chargebacks/DIALOG', false);
      }
    },
     onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  data() {
    return {
      items: [],
      isMobile: false,
      headers: [
        { text: 'Id' },
        { text: 'Valor' },
        { text: 'Pagamento' },
        { text: 'Bandeira' },
        { text: 'Data' },
        { text: 'Enviar Recibo' },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid #636366
;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #f5f5f5;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
  .v-chip.invoice.false    { background-color: var(--danger-color, #B71C1C) !important; }
  .v-chip.invoice.true    { background-color: var(--success-color, #1B5E20) !important; }
</style>
